import { defineSetting } from '../../settingsRegistry';

declare module '../../settingsRegistry' {
  interface Settings {
    /**
     * Lane FX-PIXEL (render/fx/pixelRules.ts, docs/research/C0_VFX_PIXEL.md): skill effects drawn as pixel art on the
     * scene grid (master-palette ramps, dither instead of see-through light, a dark outline, held 12 fps frames).
     * Off: the effects as before (for comparison).
     */
    fxPixel: boolean;
  }
}

defineSetting({
  key: 'fxPixel',
  default: false,
  order: 47,
  menu: { group: 'visual', label: 'เอฟเฟกต์แบบพิกเซล' },
});
